import * as React from 'react'
import { Popup } from '@/ui/overlays/Popup'
import { Button } from '@/ui/button'
import { FaIcon, faBellRegular } from '@/lib/fa'
import { Switch } from '@/ui/form/primitives/Switch'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { NewsItem } from '@/modules/shared/query-client/useQueryNews'
import { NewsEntry } from './NewsEntry'

type Props = {
  open: boolean
  items: NewsItem[]
  muted?: boolean
  onMutedChange?: (muted: boolean) => void
  onClose: () => void
}

export const WhatsNewPopup: React.FC<Props> = ({
  open,
  items,
  muted = false,
  onMutedChange,
  onClose,
}) => {
  const { tSafe } = useLocalize()

  if (items.length === 0) return null

  return (
    <Popup
      open={open}
      onClose={onClose}
      contentClassName="tw-w-[min(560px,92vw)] !tw-bg-base-100 !tw-p-0 !tw-rounded-xl"
    >
      <div className="tw-flex tw-items-center tw-gap-3 tw-border-b tw-border-base-300 tw-px-5 tw-py-4 tw-pr-12">
        <span className="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary/10">
          <FaIcon icon={faBellRegular} className="tw-h-4 tw-w-4 tw-text-primary" />
        </span>
        <div className="tw-min-w-0">
          <h2 className="tw-text-base tw-font-semibold tw-text-content-base">
            {tSafe('news.whats-new', 'Co nowego w EasyTacho')}
          </h2>
          <p className="tw-text-xs tw-text-neutral">
            {items.length === 1
              ? tSafe('news.one-change', '1 nowa zmiana od Twojej ostatniej wizyty')
              : `${items.length} ${tSafe('news.many-changes', 'nowych zmian od Twojej ostatniej wizyty')}`}
          </p>
        </div>
      </div>

      <div className="custom-scrollbar tw-flex tw-max-h-[60vh] tw-flex-col tw-gap-2.5 tw-overflow-y-auto tw-px-5 tw-py-4">
        {items.map((item) => (
          <NewsEntry key={item.id} item={item} highlighted />
        ))}
      </div>

      <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-border-t tw-border-base-300 tw-px-5 tw-py-3">
        <label className="tw-mb-0 tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-xs tw-text-neutral">
          <Switch
            checked={muted}
            onChange={(e) => onMutedChange?.(e.target.checked)}
          />
          <span>
            {tSafe(
              'news.mute-announcements',
              'Nie pokazuj tego okna przy kolejnych aktualizacjach',
            )}
          </span>
        </label>
        <Button
          size="sm"
          variant="primary"
          onClick={onClose}
          text={tSafe('news.got-it', 'Rozumiem')}
        />
      </div>
    </Popup>
  )
}
